import React, { useState, useContext, useEffect } from 'react';
import { addcontext } from '../../ContextShare/ContextShare';
import DatePicker from 'react-datepicker';
import { Icon } from '@iconify/react';
import { toast } from 'react-toastify';
import { AddKLA, GetKlaListForSearchFilter } from '../../Services/allApi';

function AddNewKla() {
    const [klaData, setKlaData] = useState({
        kla_no: null,
        constitution_date: null,
        dissolution_date: null,
    });
    const [existingKLA, setexistingKLA] = useState([
        // { id: 1, name: 'KLA 1' },
        // { id: 2, name: 'KLA 2' },
        // { id: 3, name: 'KLA 3' },

    ]);
    const [isKlaAdded, setisKlaAdded] = useState(true)

    const GetExistingKLA = async () => {
        const result = await GetKlaListForSearchFilter()
        console.log(result);
        const newKlalist = result.data?.data?.map((klas) => (
            { id: klas.kla_id, name: `KLA ${klas.kla_no}` }
        ))
        setexistingKLA(newKlalist)
    }
    useEffect(() => {
        GetExistingKLA()
    }, [isKlaAdded])

    const handleSave = async () => {

        const token = sessionStorage.getItem('access_token')
        const reqHeader = {
            "Content-Type": "application/json",
            "Authorization": `${token}`
        };
        var datToApi
        if (klaData.dissolution_date) {
            datToApi = {
                kla_no: Number(klaData.kla_no),
                constitution_date: klaData.constitution_date,
                dissolution_date: klaData.dissolution_date
            }
        }
        else {
            datToApi = {
                kla_no: Number(klaData.kla_no),
                constitution_date: klaData.constitution_date
            }
        }
        console.log(datToApi);
        if (datToApi?.kla_no && datToApi?.constitution_date) {
            const res = await AddKLA(datToApi, reqHeader)
            console.log(res);
            if (res?.status == 200) {
                toast.success("KLA added successfully")
                setKlaData({
                    kla_no: null,
                    constitution_date: null,
                    dissolution_date: null,
                })
                setisKlaAdded(!isKlaAdded)
            }
            else {
                // console.log(res?.response?.data?.message);
                const messageData = res?.response?.data?.message;
                // Check if messageData is an object
                const errorMessage = typeof messageData === 'object' && messageData !== null
                    ? messageData[Object.keys(messageData)?.[0]]?.[0] // Get the first message from the object
                    : messageData; // If it's a string, use it directly
                // console.log(errorMessage);
                toast.error(errorMessage ?? "There was a problem adding kla");
            }
        }
        else {
            if (!klaData?.kla_no && !klaData?.constitution_date) {
                toast.warning("KLA and start date must be filled")
            }
            else if (klaData?.kla_no && !klaData?.constitution_date) {
                toast.warning("Start date must be filled")
            }
            else if (!klaData?.kla_no && klaData?.constitution_date) {
                toast.warning("KLA must be filled")
            }
        }

        // console.log(klaData);
    };



    return (<>
        <div className='w-full flex items-center flex-col'>
            <h3 className='text-blue-700 text-xl font-bold mt-10 mb-10 text-center'>Add KLA</h3>


            <div className='flex flex-row justify-center flex-wrap mb-10 ms-5 me-5 gap-5 w-full'>
                <div className='w-3/12 flex flex-col'>
                    <label htmlFor="membername">KLA Number</label>
                    <input
                        id='membername'
                        value={klaData.kla_no}
                        onChange={(e) => setKlaData({ ...klaData, kla_no: e.target.value })}
                        type="number"
                        className='w-full h-10 rounded-lg border border-gray-700 px-2'
                    />
                </div>

                <div className='w-3/12 flex flex-col'>
                    <label htmlFor='startdate'>Start date of the KLA </label>
                    <input
                        type='date'
                        id='startdate'
                        value={klaData.constitution_date}
                        onChange={(e) => setKlaData({ ...klaData, constitution_date: e.target.value })}
                        className='w-full h-10 rounded-lg border border-gray-700 px-2'
                        isClearable
                    />
                </div>

                <div className='w-3/12 flex flex-col'>
                    <label htmlFor='enddate'>Ending date of the KLA</label>
                    <input
                        type='date'
                        id='enddate'
                        value={klaData.dissolution_date}
                        onChange={(e) => setKlaData({ ...klaData, dissolution_date: e.target.value })}
                        className='w-full h-10 rounded-lg border border-gray-700 px-2'
                        isClearable
                    />
                </div>



            </div>

            <br />
            <div className='w-2/12'>
                <button className='w-full py-2 bg-primary text-white rounded-full' onClick={handleSave}>Save</button>
            </div>

            <div className='w-10/12 mt-10 border bg-success '>
                <h4 className='text-blue-700 text-lg font-bold mb-5 mt-5 text-center'>Existing KLA</h4>
                <div className='flex flex-col items-center mb-5'>
                    {existingKLA?.map(kla => (
                        <div key={kla.id} className='bg-white shadow-md rounded-lg px-4 py-2 mb-2 w-6/12 border border-gray-200'>
                            <div className='text-lg font-semibold'>{kla.name}</div>
                        </div>
                    ))}
                </div>
            </div>

        </div>

        {/* <ToastContainer
                position="top-center"
                autoClose={4000}
                hideProgressBar={false}
                
                newestOnTop={false}
                closeOnClick
                rtl={false}
                // pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            /> */}
    </>
    );
}

export default AddNewKla;
